const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fa698293-542f-4085-a126-fc192e6c8e43",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.4 16.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.8,16.4H2.6A2.61,2.61,0,0,1,0,13.8V9.6A2.6,2.6,0,0,1,2.6,7H4.7a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5H2.6A1.6,1.6,0,0,0,1,9.6v4.2a1.6,1.6,0,0,0,1.6,1.6H13.8a1.6,1.6,0,0,0,1.6-1.6V9.6A1.6,1.6,0,0,0,13.8,8H11.7a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.1a2.6,2.6,0,0,1,2.6,2.6v4.2A2.61,2.61,0,0,1,13.8,16.4ZM12.75,5.05a.48.48,0,0,0,0-.7L8.55.15a.48.48,0,0,0-.7,0l-4.2,4.2a.49.49,0,0,0,.7.7L8.2,1.21l3.85,3.84a.48.48,0,0,0,.7,0ZM8.7,11.7V.5A.5.5,0,0,0,8.2,0a.5.5,0,0,0-.5.5V11.7a.5.5,0,0,0,.5.5A.51.51,0,0,0,8.7,11.7Z",
    style: {
      fill: "#2680eb"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c3693cab5af0ed91e95f6dbd13d31c50.svg";
export { ForwardRef as ReactComponent };